import { render, staticRenderFns } from "./SmartClassify.vue?vue&type=template&id=44dd7ee3&scoped=true&"
import script from "./SmartClassify.vue?vue&type=script&lang=js&"
export * from "./SmartClassify.vue?vue&type=script&lang=js&"
import style0 from "./SmartClassify.vue?vue&type=style&index=0&id=44dd7ee3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dd7ee3",
  null
  
)

export default component.exports